module.exports = __webpack_public_path__ + "static/media/IMG_1689.f29a419d.JPG";